import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { AChatroom} from '../../class/ana-chatroom';
import { BaseConfigProvider } from '../../providers/base-config/base-config';

/**
 * Generated class for the ChatroomItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'chatroom-item',
  templateUrl: 'chatroom-item.html',
})
export class ChatroomItemComponent  {
  text: string;

  @Input() chatroom: AChatroom;
  @Input() index: number;

  sorts = BaseConfigProvider.sort_string;

  constructor() {}

  choosed_sort;

}



// WEBPACK FOOTER //
// ./src/components/chatroom-item/chatroom-item.ts